module.exports = __webpack_public_path__ + "media/blink-eyes.359812e0.mp3";